import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { ContentBody } from '../pieces/ContentBody';
import { Footer } from './comments/Footer';
import { Header } from './comments/Header';
import {
  useDownvoteCommentMutation,
  useNeutralizeCommentVoteMutation,
  useUpvoteCommentMutation,
} from '../../store/api/commentApi';

export function CommentItem({ commentitem, threadId }) {
  const [isUpvoted, setIsUpvoted] = useState(false);
  const [isDownvoted, setIsDownvoted] = useState(false);
  const { currentUser, status } = useSelector((state) => state.auth);
  const authenticated = status === 'authenticated';

  const [upvoteComment] = useUpvoteCommentMutation();
  const [downvoteComment] = useDownvoteCommentMutation();
  const [neutralizeCommentVote] = useNeutralizeCommentVoteMutation();

  const sharedData = {
    url: window.location.href,
    title: `Here is a cool comment by ${commentitem.owner.name}`,
    text: `${
      commentitem.content.length >= 240
        ? commentitem.content.substring(0, 239).concat('...')
        : commentitem.content
    }`,
  };

  const onUpvoteButtonClick = () => {
    if (authenticated && isUpvoted) {
      const newUpvotesBy = commentitem.upVotesBy.filter(
        (voterId) => voterId !== currentUser.id
      );
      neutralizeCommentVote({
        threadId,
        commentId: commentitem.id,
        newUpvotesBy,
        newDownvotesBy: commentitem.downVotesBy,
      });
    } else if (authenticated && !isDownvoted) {
      const newUpvotesBy = [...commentitem.upVotesBy, currentUser.id];
      upvoteComment({ threadId, commentId: commentitem.id, newUpvotesBy });
    } else if (authenticated && isDownvoted) {
      const newDownvotesBy = commentitem.downVotesBy.filter(
        (voterId) => voterId !== currentUser.id
      );
      const newUpvotesBy = [...commentitem.upVotesBy, currentUser.id];
      neutralizeCommentVote({
        threadId,
        commentId: commentitem.id,
        newUpvotesBy,
        newDownvotesBy,
      });
      upvoteComment({ threadId, commentId: commentitem.id, newUpvotesBy });
    } else {
      document.getElementById('loginDialog').showModal();
    }
  };

  const onDownvoteButtonClick = () => {
    if (authenticated && isDownvoted) {
      const newDownvotesBy = commentitem.downVotesBy.filter(
        (voterId) => voterId !== currentUser.id
      );
      neutralizeCommentVote({
        threadId,
        commentId: commentitem.id,
        newUpvotesBy: commentitem.upVotesBy,
        newDownvotesBy,
      });
    } else if (authenticated && !isUpvoted) {
      const newDownvotesBy = [...commentitem.downVotesBy, currentUser.id];
      downvoteComment({ threadId, commentId: commentitem.id, newDownvotesBy });
    } else if (authenticated && isUpvoted) {
      const newUpvotesBy = commentitem.upVotesBy.filter(
        (voterId) => voterId !== currentUser.id
      );
      const newDownvotesBy = [...commentitem.downVotesBy, currentUser.id];
      neutralizeCommentVote({
        threadId,
        commentId: commentitem.id,
        newUpvotesBy,
        newDownvotesBy,
      });
      downvoteComment({
        threadId,
        commentId: commentitem.id,
        newUpvotesBy,
        newDownvotesBy,
      });
    } else {
      document.getElementById('loginDialog').showModal();
    }
  };

  const onShareButtonClick = () => {
    if (isSecureContext) {
      navigator.share(sharedData);
    } else {
      alert(
        'You cant do this in unsecured access. Share it from browser address bar instead.'
      );
    }
  };

  useEffect(() => {
    if (currentUser && commentitem.upVotesBy.includes(currentUser.id)) {
      setIsUpvoted(true);
    }
    if (currentUser && !commentitem.upVotesBy.includes(currentUser.id)) {
      setIsUpvoted(false);
    }
    if (currentUser && commentitem.downVotesBy.includes(currentUser.id)) {
      setIsDownvoted(true);
    }
    if (currentUser && !commentitem.downVotesBy.includes(currentUser.id)) {
      setIsDownvoted(false);
    }
  }, [currentUser, commentitem]);

  return (
    <div className="group container relative mx-auto break-words rounded-lg py-2">
      <Header
        ava={commentitem.owner.avatar}
        userId={commentitem.owner.id}
        name={commentitem.owner.name}
        createdAt={commentitem.createdAt}
      />
      <div className="my-2">
        <ContentBody text={commentitem.content} />
      </div>
      <Footer
        upvotes={commentitem.upVotesBy}
        downvotes={commentitem.downVotesBy}
        isUpvoted={isUpvoted}
        isDownvoted={isDownvoted}
        handleUpvoteAction={onUpvoteButtonClick}
        handleDownvoteAction={onDownvoteButtonClick}
        handleShareAction={onShareButtonClick}
      />
    </div>
  );
}

CommentItem.propTypes = {
  threadId: PropTypes.string.isRequired,
  commentitem: PropTypes.shape({
    id: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
    owner: PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      avatar: PropTypes.string.isRequired,
    }),
    createdAt: PropTypes.string.isRequired,
    upVotesBy: PropTypes.array.isRequired,
    downVotesBy: PropTypes.array.isRequired,
  }).isRequired,
};
